export default "__VITE_ASSET__fIc8VpkF__"